export default function Footer() {
  return (
    <footer className="w-full bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="font-heading text-2xl md:text-3xl font-bold mb-3">
              hipobuyspread<span className="text-primary-400">.baby</span>
            </h3>
            <p className="text-background-50/60 text-sm leading-relaxed mb-6 max-w-xs">
              Independent educational resource providing shopping guides, product discovery tools, 
              and spreadsheet comparisons. We are not affiliated with any shopping agent platform.
            </p>
            <div className="flex items-center gap-3">
              {['twitter-x-fill', 'reddit-fill', 'pinterest-fill', 'youtube-fill'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 rounded-full border border-background-50/20 flex items-center justify-center hover:bg-background-50/10 transition-colors cursor-pointer"
                >
                  <i className={`ri-${icon} text-sm w-4 h-4 flex items-center justify-center`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="space-y-5">
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/40 mb-2">Disclaimer</h4>
              <p className="text-sm text-background-50/60 leading-relaxed">
                This website is an independent educational resource. We provide guides, comparisons 
                and information about shopping spreadsheets. We are not affiliated with Hipobuy, 
                Kakobuy, CSSBuy, Superbuy, or Oopbuy.
              </p>
            </div>
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/40 mb-2">Contact</h4>
              <p className="text-sm text-background-50/60">contact@hipobuyspread.baby</p>
            </div>
          </div>

          <div>
            <div className="rounded-2xl overflow-hidden h-48 bg-foreground-900">
              <img
                src="https://readdy.ai/api/search-image?query=Fashion%20products%20flatlay%20on%20dark%20surface%2C%20sneakers%20accessories%20and%20clothing%20editorial%20photography%2C%20warm%20moody%20lighting%2C%20luxury%20aesthetic%20with%20soft%20shadows&width=600&height=400&seq=footer-visual&orientation=landscape"
                alt="Shopping resources"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} hipobuyspread.baby — Independent Shopping Education Resource
          </p>
          <div className="flex items-center gap-6">
            <a href="/" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">
              Home
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer"
            >
              Kaspreadsheet
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}